import { Log } from 'oidc-client-ts';

export default function handleLoginRedirect(userManager) {
    const runsInIframe = window?.parent && window.parent !== window;

    if (runsInIframe) {
        // Silent redirect within an <iframe>
        Log.logger = console;
        Log.level = Log.INFO;

        // This will propagate the received information provided via
        // query parameters to the parent frame
        return userManager.signinSilentCallback();
    } else {
        // TODO: If your SPA lives inside the main frontend bucket you need to
        //       redirect to a "physical" `/index.html` because the bucket
        //       is configured to return the root index of the monolith if no
        //       exact match is found
        return userManager
            .signinRedirectCallback()
            .catch((err) => {
                console.log('signinRedirectCallback error', userManager, err);
            })
            .then(() => {
                window.location.href = window.location.href.replace('/redirect', '/');
            });
    }
}
